import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'

import './Grid.scss'

interface Props {
  children: ReactNode
  className?: string | Object
}

export const GridContainer: FC<Props> = ({ children, className }) => (
  <div className={classNames('ui-grid-container', className)}>{children}</div>
)
